// src/components/BackButton.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import iconBack from '../../assets/icon/arrow/indietro.png';

const BackButton = ({ className = '', children, ...props }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Button onClick={handleBack} className={className} {...props}>
      {children ? (
        children
      ) : (
        <img src={iconBack} alt="Indietro" className="w-5 h-5" />
      )}
    </Button>
  );
};

export default BackButton;
